// Verksamhetsland (jurisdiktion) — separerat från UI-språk.
// Land styr vilken juridisk version (villkor, integritetspolicy, cookies)
// som gäller för ett företagskonto. Språk styr endast UI.
//
// OBS: Engelska är INTE ett verksamhetsland — endast ett UI-språk.

export const SUPPORTED_COUNTRIES = [
  { code: "sv", label: "Sverige", flag: "🇸🇪", originalLanguage: "sv" },
  { code: "no", label: "Norge", flag: "🇳🇴", originalLanguage: "no" },
  { code: "da", label: "Danmark", flag: "🇩🇰", originalLanguage: "da" },
  { code: "fi", label: "Finland", flag: "🇫🇮", originalLanguage: "fi" },
  { code: "is", label: "Ísland", flag: "🇮🇸", originalLanguage: "is" },
] as const;

export type CountryCode = (typeof SUPPORTED_COUNTRIES)[number]["code"];

export const isCountryCode = (v: unknown): v is CountryCode =>
  typeof v === "string" && SUPPORTED_COUNTRIES.some((c) => c.code === v);

export const getCountryLabel = (code: string): string =>
  SUPPORTED_COUNTRIES.find((c) => c.code === code)?.label ?? code.toUpperCase();

export const getCountryFlag = (code: string): string =>
  SUPPORTED_COUNTRIES.find((c) => c.code === code)?.flag ?? "";

export const getOriginalLanguage = (country: string): string =>
  SUPPORTED_COUNTRIES.find((c) => c.code === country)?.originalLanguage ?? "sv";
